import React from 'react';
import { Card, Table, Button, Row, Col } from 'react-bootstrap';
import { FaArrowLeft } from 'react-icons/fa';
import Loading from '~/Components/Loading';

export default function DetalheAtivo({ ativo, dados, isLoading, onVoltar }) {
  const titulo = ativo.empreendimento + ' - Ativo: ' + ativo.codigo_ativo +
    ' - QD: ' + ativo.quadra + '/LT: ' + ativo.lote;

  const formatDate = dateStr => {
    if (!dateStr) return '';
    const d = new Date(dateStr);
    return d.toLocaleDateString('pt-BR') + ' ' + d.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });
  };

  const formatDateOnly = dateStr => {
    if (!dateStr) return '';
    return new Date(dateStr).toLocaleDateString('pt-BR');
  };

  return (
    <Card className="mb-2 shadow-sm" style={{ borderTop: '3px solid #0747a6' }}>
      <Card.Header className="d-flex align-items-center" style={{ backgroundColor: '#0747a6', color: '#fff' }}>
        <Button variant="success" size="sm" onClick={onVoltar} className="mr-3">
          <FaArrowLeft /> Voltar
        </Button>
        <strong style={{ fontSize: '1.1rem' }}>{titulo}</strong>
      </Card.Header>
      <Card.Body>
        {isLoading && <Loading label="Carregando detalhe do ativo" />}

        {dados && (
          <>
            {/* Historico de Reservas */}
            <Card className="mb-3" style={{ borderTop: '2px solid #0747a6' }}>
              <Card.Header style={{ backgroundColor: '#0747a6', color: '#fff', padding: '6px 12px' }}>
                <strong>Historico de Reservas do lote</strong>
              </Card.Header>
              <Card.Body className="p-2">
                {dados.historico_reservas && dados.historico_reservas.length > 0 ? (
                  <div className="table-responsive">
                    <Table hover size="sm" bordered>
                      <thead>
                        <tr>
                          <th>Corretor</th>
                          <th className="text-center">Status</th>
                          <th className="text-center">Reservado</th>
                          <th className="text-center">Validade</th>
                          <th className="text-center">Cancelado em</th>
                          <th>Cancelado por</th>
                          <th>Pre-venda</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dados.historico_reservas.map((item, idx) => (
                          <tr key={idx} style={{ backgroundColor: item.pre_venda > 0 ? '#dff0d8' : '' }}>
                            <td>{item.corretor}</td>
                            <td className="text-center">{item.status}</td>
                            <td className="text-center">{formatDate(item.reserva)}</td>
                            <td className="text-center">{formatDate(item.validade)}</td>
                            <td className="text-center">{formatDate(item.data_cancelamento)}</td>
                            <td>{item.usuario_cancelamento}</td>
                            <td>{item.pre_venda > 0 ? item.pre_venda : ''}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                ) : (
                  <span className="badge badge-info">Nao ha historico de reservas para esse ativo.</span>
                )}
              </Card.Body>
            </Card>

            <Row>
              {/* Fila Atual Ativa */}
              <Col md={5}>
                <Card className="mb-3" style={{ borderTop: '2px solid #0747a6' }}>
                  <Card.Header style={{ backgroundColor: '#0747a6', color: '#fff', padding: '6px 12px' }}>
                    <strong>Fila atual ativa do lote</strong>
                  </Card.Header>
                  <Card.Body className="p-2">
                    {dados.fila_atual && dados.fila_atual.length > 0 ? (
                      <div className="table-responsive">
                        <Table hover size="sm" bordered>
                          <thead>
                            <tr>
                              <th className="text-center">Corretor</th>
                              <th className="text-center">Imobiliaria</th>
                              <th className="text-center">Entrada</th>
                            </tr>
                          </thead>
                          <tbody>
                            {dados.fila_atual.map((item, idx) => (
                              <tr key={idx}>
                                <td className="text-center">{item.corretor}</td>
                                <td className="text-center">{item.imobiliaria}</td>
                                <td className="text-center">{formatDate(item.entrada)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    ) : (
                      <span className="badge badge-info">Nao ha fila para esse ativo</span>
                    )}
                  </Card.Body>
                </Card>
              </Col>

              {/* Historico da Fila */}
              <Col md={7}>
                <Card className="mb-3" style={{ borderTop: '2px solid #0747a6' }}>
                  <Card.Header style={{ backgroundColor: '#0747a6', color: '#fff', padding: '6px 12px' }}>
                    <strong>Historico da fila do lote</strong>
                  </Card.Header>
                  <Card.Body className="p-2">
                    {dados.historico_fila && dados.historico_fila.length > 0 ? (
                      <div className="table-responsive">
                        <Table hover size="sm" bordered>
                          <thead>
                            <tr>
                              <th className="text-center">Operador</th>
                              <th className="text-center">Corretor</th>
                              <th className="text-center">Movimentacao</th>
                              <th className="text-center">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            {dados.historico_fila.map((item, idx) => (
                              <tr key={idx} style={{ backgroundColor: item.status === 'Entrou' ? '#dff0d8' : '#f2dede' }}>
                                <td className="text-center">{item.nome_operador}</td>
                                <td className="text-center">{item.nome_corretor}</td>
                                <td className="text-center">{formatDate(item.movimentacao)}</td>
                                <td className="text-center">{item.status}</td>
                              </tr>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                    ) : (
                      <span className="badge badge-info">Nao ha historico de fila para esse ativo</span>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </>
        )}
      </Card.Body>
    </Card>
  );
}
